import React, { useEffect } from 'react'

export const EditFormNotification = ({ message, onDismiss }) => {
  useEffect(() => {
    try {
      const notification = document.getElementById('edit-notification')
      notification?.addEventListener('wbdismiss', onDismiss)
      return () => {
        notification?.removeEventListener('wbdismiss', onDismiss)
      }
    } catch (error) {
      console.error(
        'Dismissal event listener could not be attached to wb-notification',
        error,
      )
    }
  }, [])

  return (
    <wb-notification-host position="top-end">
      <wb-notification
        theme="dark"
        mode="warning"
        class="wb-margin-bottom-s"
        id="edit-notification"
      >
        <wb-notification-content>{message}</wb-notification-content>
      </wb-notification>
    </wb-notification-host>
  )
}
